<template>
  <o-view class="c-sales-view" :has-white-background="true" :no-scroll="true">
    <o-view :bottom-padding="true">
      <o-nav-bar
        title="Cambio-inschrijving"
        :has-back-button="true"
        :has-close-button="true"
        :is-overlay="true"
      />
      <o-section-header title="Rijbewijs">
        <template #right>
          <o-icon icon="info" @click.native="showOverlay('info')" />
        </template>
      </o-section-header>
      <o-section>
        <p>Gelieve de volgende gegevens aan te vullen.</p>
        <o-text-input label="Nummer rijbewijs" value="123-4567890-12" />
      </o-section>
      <o-section>
        <o-text-input
          icon="date"
          type="date"
          label="Begindatum geldigheid"
          value="1991-02-26"
        />
      </o-section>
      <o-section>
        <o-text-input label="Uitgifteplaats" value="Gent" />
      </o-section>
      <o-section :small-padding="true">
        <o-checkbox>Ik heb minstens een rijbewijs B</o-checkbox>
      </o-section>
      <o-overlay ref="info" title="Informatie rijbewijs">
        <template #form>
          <o-driver-info />
        </template>
      </o-overlay>
    </o-view>
    <o-pay-button
      label="Verder"
      to="/sales/car/cambio/onboarding/driver-picture"
    />
  </o-view>
</template>

<script>
import OFavoriteToggle from '@/components/OFavoriteToggle.vue'
import OHeaderImage from '@/components/OHeaderImage.vue'
import OPayButton from '@/components/OPayButton.vue'
import OStarRating from '@/components/OStarRating.vue'
import ODriverInfo from '@/components/overlays/ODriverInfo.vue'
export default {
  name: 'CambioCurrent',
  components: {
    ODriverInfo,
    OFavoriteToggle,
    OHeaderImage,
    OPayButton,
    OStarRating
  }
}
</script>
